module.exports = __webpack_public_path__ + "img/symbol_7.bd069a33.png";